'use client'
import { ErrorComponent } from '@/components'
import React from 'react'

const Error = ({ reset }) => {
  return (
    <div className='w-full h-full flex justify-center items-center'>
      <ErrorComponent errorMessage={'Ocurrio un error en el registro, intentalo mas tarde'} reset={reset} />
    </div>
  )
}

export default Error